export const environment = {
  production: true,
  apiUrl: 'https://api.whataniceoffice.com/graphql',
  sentry: 'https://559dd05eebc647bab32367ce99213b9e@o1021411.ingest.sentry.io/5987319',
  envName: 'production'
};
